import { render } from "./Tag.vue?vue&type=template&id=ddeed540&scoped=true"
import script from "./Tag.vue?vue&type=script&setup=true&lang=js"
export * from "./Tag.vue?vue&type=script&setup=true&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=ddeed540&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddeed540"],['__file',"src/components/Paragraphs/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddeed540"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddeed540', __exports__)) {
    api.reload('ddeed540', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=ddeed540&scoped=true", () => {
    api.rerender('ddeed540', render)
  })

}


export default __exports__